<template>
  <footer class="bg-[#072653]">
    <div class="mx-auto max-w-7xl px-6 pb-8 pt-16 sm:pt-24 lg:px-8 lg:pt-32">
      <div class="xl:grid xl:grid-cols-3 xl:gap-8">
        <div class="space-y-8">
          <img class="h-16 rounded-full" src="@/assets/Logos/logo1.png"/>
          <p class="text-balance text-sm/6 text-gray-300">Association reconnue d'Intérêt général - Art. 200-1-b et 238 bis-1-a du CGI</p>
          
          <!-- Adresses -->
          <div class="space-y-3">
            <div>
              <h4 class="text-sm font-semibold text-white mb-1">Siège social</h4>
              <p class="text-sm text-gray-300">Immeuble CMCI – 2 rue Henri Barbusse – 13001 Marseille</p>
            </div>
            <div>
              <h4 class="text-sm font-semibold text-white mb-1">Adresse postale</h4>
              <p class="text-sm text-gray-300">Bâtiment Le Murano – CS 80390 – 22 boulevard Robert Schumann – 13235 Marseille Cedex 02</p>
            </div>
          </div>
          
          <div class="flex gap-x-6">
            <a v-for="item in navigation.social" :key="item.name" :href="item.href"    target="_blank"  class="text-gray-400 hover:text-gray-300">
              <span class="sr-only">{{ item.name }}</span>
              <component :is="item.icon" class="size-6" aria-hidden="true" />
            </a>
          </div>
        </div>
        <div class="mt-16 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0">
          <div class="md:grid md:grid-cols-2 md:gap-8">
            <div>
              <h3 class="text-sm/6 font-semibold text-white">Solutions</h3>
              <ul role="list" class="mt-6 space-y-4">
                <li v-for="item in navigation.socialnet" :key="item.name">
                  <a :href="item.href" class="text-sm/6 text-gray-400 hover:text-white">{{ item.name }}</a>
                </li>
              </ul>
            </div>
            <div class="mt-10 md:mt-0">
              <h3 class="text-sm/6 font-semibold text-white">Support</h3>
              <ul role="list" class="mt-6 space-y-4">
                <li v-for="item in navigation.support" :key="item.name">
                  <a :href="item.href" class="text-sm/6 text-gray-400 hover:text-white">{{ item.name }}</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="md:grid md:grid-cols-2 md:gap-8">
            <div class="mt-10 md:mt-0">
              <h3 class="text-sm/6 font-semibold text-white">Politiques</h3>
              <ul role="list" class="mt-6 space-y-4">
                <li v-for="item in navigation.legal" :key="item.name">
                  <a :href="item.href" class="text-sm/6 text-gray-400 hover:text-white">{{ item.name }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-16 border-t border-white/10 pt-8 sm:mt-20 lg:mt-24">
        <p class="text-sm/6 text-gray-400">&copy; Site par <a href="https://hbc-group.fr/" target="_blank">High Base Code</a></p>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { defineComponent, h } from 'vue'

const navigation = {
  socialnet: [
    { name: 'Nous sommes sur instagram', href: 'https://www.instagram.com/merite_maritime/#' },
    { name: 'Nous sommes sur Linkedin', href: 'https://www.linkedin.com/company/fnmm/posts/?feedView=all' },
    { name: 'Nous contacter', href: '/support' },
  ],
  support: [
    { name: 'Contacter le support', href: '/support' },
    // { name: 'FAQ', href: '#' },
    { name: 'Support', href: '/support' },
  ],
  legal: [
    { name: 'Politique de confidentialité', href: '/politiques' },
    { name: 'Conditions d\'utilisation', href: '/politiques' },
    { name: 'Politique de cookies', href: '/politiques' },
    { name: 'Politique de gestion des droits d\'auteur', href: '/politiques' },
    { name: 'Conditions de la messagerie', href: '/politiques#' },
    { name: 'Politique de sécurité', href: '/politiques' },
  ],
  social: [
    {
      name: 'LinkedIn',
      href: 'https://www.linkedin.com/company/fnmm/posts/?feedView=all',
      icon: defineComponent({
        render: () =>
            h('svg', { fill: 'currentColor', viewBox: '0 0 24 24' }, [
              h('path', {
                d: 'M19 0H5C2.239 0 0 2.239 0 5v14c0 2.761 2.239 5 5 5h14c2.761 0 5-2.239 5-5V5c0-2.761-2.239-5-5-5zM8.339 18.667H5.668V9.667h2.671v9zM7.003 8.486a1.555 1.555 0 110-3.111 1.555 1.555 0 010 3.111zM19 18.667h-2.671v-4.334c0-1.033-.863-1.666-1.825-1.666-.962 0-1.829.686-1.829 1.666v4.334h-2.671v-9h2.671v1.401c.489-.826 1.648-1.467 2.986-1.467 2.134 0 3.338 1.388 3.338 3.467v5.599z',
              }),
            ]),
      }),
    },
    {
      name: 'Instagram',
      href: 'https://www.instagram.com/merite_maritime/#',
      icon: defineComponent({
        render: () =>
            h('svg', { fill: 'currentColor', viewBox: '0 0 24 24' }, [
              h('path', {
                'fill-rule': 'evenodd',
                d: 'M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z',
                'clip-rule': 'evenodd',
              }),
            ]),
      }),
    },
  ],
}
</script>